function showToast(message, time = 3000, type = 'default') {
    const toast = document.getElementById('edas-toast');

    if (!toast) {
        console.error('Toast element not found');
        return;
    }

    // Limpiar clases anteriores
    toast.className = '';

    // Establecer el mensaje
    toast.innerHTML = message;

    // Agregar clase show
    toast.classList.add('show');

    // Agregar tipo si se especifica
    if (type && type !== 'default') {
        toast.classList.add(type);
    }

    // Ocultar después del tiempo especificado
    setTimeout(() => {
        hideToast();
    }, time);
}

function hideToast() {
    const toast = document.getElementById('edas-toast');
    if (toast) {
        toast.classList.remove('show');

        // Limpiar todas las clases después de la animación
        setTimeout(() => {
            toast.className = '';
        }, 400); // Tiempo de la transición CSS
    }
}

// Función para ocultar toast al hacer click (opcional). Comprobr primero si el elemento existe.
if (document.getElementById('edas-toast')) {
    document.getElementById('edas-toast').addEventListener('click', hideToast);
}


// Función mejorada compatible con tu API actual
function showToastLegacy(message, time = 2000, error = false) {
    showToast(message, time, error ? 'danger' : 'default');
}
